module.exports = __webpack_public_path__ + "static/media/cheeseburger-bit.132bad2f.svg";